{}module.exports = (typeof window === 'undefined' ? {} : window).env = {
    captcha: {
        key: '6LcIvgETAAAAAIMCwRem9WxT0UvUPk_3209UrzDJ',
        maxFailedAttempts: 50,
    },
    extensionIds: {
        chrome: 'nhhldecdfagpbfggphklkaeiocfnaafm',
        opera: 'jnlcnnodlcecoagnkiplcbmpnemcibnj',
    },
    facebookAppId: '565837326835543',
    publicPath: 'https://storage.googleapis.com/fesetlockone/',
    urls: {
        customAppWidgetIframePrefix: 'https://www.setlockone.com/sd/',
        premiumIconPrefix: 'https://www.setlockone.com/',
        samlAppLogo: (slug, type = 'logo') => `https://www.setlockone.com/apps/${slug}/images/${type}.png`,
        m365ps1: 'https://cdn.saaspass.com/releases/v3/ms365/saaspass_m365_federation.ps1',
        m365txt: 'https://cdn.saaspass.com/releases/v3/ms365/saaspass_m365_federation.txt',
    },
    websocket: {
        url: 'wss://www.setlockone.com/ws',
        username: 'd16b8f79-c6a0-4538-915c-3202bc0e3f66',
        password: 'f2734acc-a0a1-4f32-b265-e1828887197d',
        virtualHost: '/wsmq',
    },
};


// WEBPACK FOOTER //
// /var/tmp/env.build.js